<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__sluserteam}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:sluserteam:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:sluserteam:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalCount" label="团队人数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="directCount" label="直属人数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="secondCount" label="非直属人数" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalApply" label="累计进件" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalLoanAmount" label="累计放款" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalAwardAmount" label="累计津帖" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalRoyaltyAmount" label="累计提成" header-align="center" align="center"></el-table-column>
        <el-table-column prop="totalActiveAmount" label="累计活动奖励" header-align="center" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:sluserteam:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:sluserteam:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './sluserteam-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/sluserteam/page',
        getDataListIsPage: true,
        exportURL: '/sys/sluserteam/export',
        deleteURL: '/sys/sluserteam',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
